module.exports = __webpack_public_path__ + "static/media/24.e7e8fd0f.jpg";